/* @flow */
import * as React from 'react';
import invariant from 'invariant';

import Dialog from 'components/Dialog.jsx';
import Group from 'entities/Group';
import GroupMembership from 'entities/GroupMembership';
import LoadingIndicator from 'components/LoadingIndicator.jsx';
import OrgRoleDropdown from 'groups/components/OrgRoleDropdown.jsx';
import Text from 'components/Text.jsx';
import TitleHeader from 'components/TitleHeader.jsx';
import UserAvatar from 'users/components/UserAvatar.jsx';

import './styles/BatchRoleCorrectionModal.scss';

type Props = {
  group: Group,
  loading?: boolean,
  onClose?: ?Function,
  groupMemberships: GroupMembership[],
  onUserRoleSave?: (userId: Backbone$Id) => any,
  onRequestHide?: () => any, // From mountModal
};

class BatchRoleCorrectionModal extends React.Component<Props> {
  componentWillUnmount() {
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  renderMemberRow(member: GroupMembership) {
    const user = member.getUser();
    const orgAffView = member.getOrgAffiliationView();
    invariant(orgAffView, 'member missing org_affiliation_view');

    return (
      <tr key={member.id}>
        <td className="BatchRoleCorrectionModal-table-nameRow">
          <UserAvatar size="medium" user={user.toJSON()} />
          <Text truncate className="BatchRoleCorrectionModal-table-nameRow-name">
            {user.getFullName()}
          </Text>
        </td>
        <td>
          <div className="BatchRoleCorrectionModal-table-organizationDropdown">
            <OrgRoleDropdown
              userId={user.id}
              name={user.getFullName()}
              group={this.props.group}
              initialRoles={orgAffView.roles}
              potentialRoles={orgAffView.potential_roles}
              onSave={this.props.onUserRoleSave}
              canHaveRoleChanged={orgAffView.can_have_role_changed}
            />
          </div>
        </td>
      </tr>
    );
  }

  render() {
    const { onRequestHide, groupMemberships, loading } = this.props;

    return (
      <Dialog
        onRequestHide={onRequestHide}
        eventScreenName="BatchRoleCorrectionModal"
        className="BatchRoleCorrectionModal">
        <div className="BatchRoleCorrectionModal-body">
          <TitleHeader title="Modify Roles" />
          <table className="BatchRoleCorrectionModal-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Role</th>
              </tr>
            </thead>
            <tbody>{groupMemberships.map(m => this.renderMemberRow(m))}</tbody>
          </table>
          {loading && (
            <div className="BatchRoleCorrectionModal-loadingIndicator">
              <LoadingIndicator size="small" />
            </div>
          )}
        </div>
      </Dialog>
    );
  }
}

export default BatchRoleCorrectionModal;
